
import order from '@/pages/bigorder/order'
import orderFastener from '@/pages/bigorder/orderFastener'
import orderDetail from '@/pages/bigorder/order-detail'
import completeStock from '@/pages/bigorder/completeStock'
import stockList from '@/pages/bigorder/stockList'
import dayStockList from '@/pages/bigorder/day-stock-list'
import shippingList from '@/pages/bigorder/shippingList'
import deliverySheet from '@/pages/bigorder/delivery-sheet'
import scanningStock from '@/pages/bigorder/scanningStock'
import prinPurchase from '@/pages/bigorder/prinPurchase'
import QuickSetBoxNum from '@/pages/bigorder/quick-set-box-num'
import inputTS from '@/pages/bigorder/input-ts'
import test from '@/pages/test'
// import layout from '@/components/layout/layout'
const orderRouter =
[
  {
    path: '/bigorder/manage',
    component: order,
    name: 'bigorder',
    meta: {roles: ['pingtai', 'zhifa','factory', 'r4gys'], title: '备货出库大单'}
  },
  {
    path: '/bigorder/manageFastener',
    component: orderFastener,
    name: 'bigorderFastener',
    meta: {roles: ['jgj'], title: '历史订单'}
  },
  {
    path: '/bigorder/edit/',
    component: orderDetail,
    name: 'bigorderDetail',
    hidden: true,
    meta: {roles: ['shop', 'r4gys']}
  },
  {
    path: '/bigorder/completeStock',
    component: completeStock,
    name: 'bigcompleteStock',
    hidden: true,
    meta: {roles: ['shop', 'r4gys']}
  },
  {
    path: '/bigorder/test',
    name: 'bigtest',
    hidden: true,
    component: test,
    meta: {roles: ['shop', 'r4gys']}
  },
  {
    path: '/bigorder/storeList',
    name: 'bigstoreList',
    hidden: true,
    component: stockList,
    meta: {roles: ['shop', 'r4gys']}
  },
  {
    path: '/bigorder/shippingList',
    name: 'bigshippingList',
    hidden: true,
    component: shippingList,
    meta: {roles: ['shop', 'r4gys']}
  },
  {
    path: '/bigorder/scanningStock',
    name: 'bigscanningStock',
    hidden: true,
    component: scanningStock,
    meta: {roles: ['shop', 'r4gys']}
  },
  {
    path: '/bigorder/dayStockList',
    name: 'bigdayStockList',
    hidden: true,
    component: dayStockList,
    meta: {roles: ['shop', 'r4gys']}
  },
  {
    path: '/bigorder/deliverySheet',
    name: 'bigdeliverySheet',
    hidden: true,
    component: deliverySheet,
    meta: {roles: ['shop', 'r4gys']}
  },
  {
    path: '/bigorder/prinPurchase',
    name: 'bigprinPurchase',
    hidden: true,
    component: prinPurchase,
    meta: {roles: ['shop', 'r4gys']}
  },
  {
    path: '/bigorder/QuickSetBoxNum',
    name: 'bigQuickSetBoxNum',
    hidden: true,
    component: QuickSetBoxNum,
    meta: {roles: ['shop', 'r4gys'], title: '快速打包'}
  },
  {
    path: '/bigorder/inputTS',
    name: 'biginputTS',
    hidden: true,
    component: inputTS,
    meta: {roles: ['shop', 'r4gys'], title: '录入物流运单'}
  }
]
export default orderRouter



// WEBPACK FOOTER //
// ./src/router/modules/bigorder.js